export default __webpack_public_path__ + "static/media/add.cbd4f4cb.svg";